import { render, staticRenderFns } from "./ProdArch.vue?vue&type=template&id=caf672da&scoped=true"
import script from "./ProdArch.vue?vue&type=script&lang=js"
export * from "./ProdArch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf672da",
  null
  
)

export default component.exports